import React, { useState } from 'react';
import {
  Box,
  TextField,
  Stack,
  Paper,
} from '@mui/material';
import { useGlobal } from '../../contexts/GlobalContext';

const ParamsPolymarketV2 = ({ onParamsChange }) => {
  const { defaultPolymarketWalletAddress } = useGlobal();

  const [wallet, setWallet] = useState(defaultPolymarketWalletAddress || '');
  const [numStories, setNumStories] = useState(25);
  const [numHoursNewMarkets, setNumHoursNewMarkets] = useState(24);

  // Update params whenever any input changes
  React.useEffect(() => {
    const params = {
      wallet,
      num_stories: parseInt(numStories),
      num_hours_new_markets: parseInt(numHoursNewMarkets),
    };
    onParamsChange(params);
  }, [wallet, numStories, numHoursNewMarkets, onParamsChange]);

  const handleWalletChange = (e) => {
    setWallet(e.target.value);
  };

  const handleNumStoriesChange = (e) => {
    setNumStories(e.target.value);
  };

  const handleNumHoursNewMarketsChange = (e) => {
    setNumHoursNewMarkets(e.target.value);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Paper sx={{ p: 2 }}>
        <Stack spacing={2}>
          <TextField
            label="Wallet Address"
            placeholder="Enter wallet address"
            value={wallet}
            onChange={handleWalletChange}
            fullWidth
            size="small"
            variant="outlined"
          />
          <TextField
            label="Number of Stories"
            type="number"
            value={numStories}
            onChange={handleNumStoriesChange}
            fullWidth
            size="small"
            variant="outlined"
            inputProps={{ min: 1 }}
          />
          <TextField
            label="Hours for New Markets"
            type="number"
            value={numHoursNewMarkets}
            onChange={handleNumHoursNewMarketsChange}
            fullWidth
            size="small"
            variant="outlined"
            inputProps={{ min: 1 }}
          />
        </Stack>
      </Paper>
    </Box>
  );
};

export default ParamsPolymarketV2;

